import React from 'react';
import moment from 'moment';

import {
    getEventos,
} from './services/evento-service';
import Footer from './Footer';
import './styles/consultar-inscricoes.css';

class ListarEventos extends React.Component {

    constructor() {
        super();

        this.state = {
            loading: true,
            hasError: false,
            eventos: [],
        };
    }

    async componentWillMount() {
        try {
            const eventos = await getEventos();
            this.setState({ eventos, loading: false });
        } catch (error) {
            this.setState({ hasError: true });
        }
    }

    _renderTableEventos(eventos) {
        return (
            <table>
                <thead>
                    <tr>
                        <th>Nome</th>
                        <th>Data limite</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        eventos.map(x => (
                            <tr key={x.evento_id}>
                                <td>{x.nome}</td>
                                <td>{moment(x.data_final).format('DD/MM/YYYY')}</td>
                                <td>
                                    <a className="app-cursor-pointer" onClick={() => this.props.history.push(`/inscricao/${x.evento_id}`)}>Inscrever-se</a>
                                </td>
                            </tr>
                        ))
                    }
                </tbody>
            </table>
        );
    }

    render() {
        const {
            loading,
            eventos,
        } = this.state;

        return (
            <div className="wrapper">

                <nav className="app-navigation">
                    <section className="container-custom">
                        <a className="app-navigation-title" href="/">
                            <h1 className="app-title">Fórum Gaúcho de Aprendizagem Profissional - FOGAP</h1>
                        </a>
                        <ul className="app-navigation-list float-right">
                            <li className="app-navigation-item">
                                <a className="app-navigation-link" onClick={() => this.props.history.push('/login')}>Admin</a>
                            </li>
                        </ul>
                    </section>
                </nav>

                <div className="container-custom app-body">
                    <h4>Eventos em aberto</h4>
                    {
                        loading ?
                            <div>Carregando...</div> :
                            this._renderTableEventos(eventos)
                    }
                </div>

                <footer className="footer">
                    <section className="container-custom">
                        <Footer />
                    </section>
                </footer>
            </div>
        );
    }
}

export default ListarEventos;
